export default class InputCredentials
{
  constructor(id, password, accessCode) 
  {    
    this.id = id;
    this.password = password;
    this.accessCode = accessCode;
  }    
}